import { useState, useParams, FaSearch, FaFileExcel, BsSortUpAlt, noDatapng, ToastContainer, FaFilter, DataTable, FaPlusCircle, FaArrowAltCircleRight, overlayStyle, loaderStyle, moment, BiChevronDown, MdRefresh } from '../../common/common.jsx';
import Sidebar from '../Components/Sidebar.jsx';
import Topbar from '../Components/Topbar.jsx';
import Navigations from '../../common/useNavigation.js';
import MidViewSellerOrders from '../../middleware/Orders/MidViewSellerOrders.jsx';
import { Modal } from 'react-bootstrap';
import axiosJWT from '../../secureAPI/axiosJWT.js';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils.js';
import MidPlans from '../../middleware/plans/MidPlans.jsx';
import { showToast } from '../../Utils/toastUtils.js';
import { FaMinus, FaPlus } from 'react-icons/fa';


const ViewSellerOrders = () => {

    const { type, orderType } = useParams();
    const { navigateOrderDetails } = Navigations();
    const [issidebarOpen, setIssidebarOpen] = useState(true);


    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { users, userPlan, filteredCategories, orders, open, inputValue, Selected, orderTypes, seacrh, seacrhOrderId, seacrhBuyername, seacrhMinQty, seacrhMaxQty, seacrhMinAmt, seacrhMaxAmt, seacrhTodate, seacrhFromdate, seacrhUpdateTodate, seacrhUpdateFromdate, filteropen, filterSelected, setSearchOrderId, setSearchBuyername, setSearchMinQty, setSearchMaxQty, setSearchMinAmt, setSearchMaxAmt, setSearchTodate, setSearchFromdate, setSearchUpdateTodate, setSearchUpdateFromdate, setfilterOpen, setfilterSelected, setSearchOrderType, setOpen, setInputValue, setSelected, setSearch, handleupdateorderState, lgShow1, handlemodalhide, usercustomfields, handlenameChange, handleonchange, exporttoExcelData, filterDiv, setfilterDiv, getsellerOrders, handleSubmit, handleRowSelected } = MidViewSellerOrders(type, orderType);
    const { setisLoading } = MidPlans(type);

    const [lgShow, setLgShow] = useState(false)

    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var username = users[0]['FullName'];
        var RegistrationDate = users[0]['RegistrationDate'];
        var EmailAddress = users[0]['EmailAddress'];
        var RegistrationDate = moment(RegistrationDate).format('DD-MMM-YYYY');
        var ActiveUser = users[0]["Status"]
    }
    if (Array.isArray(userPlan) && userPlan.length > 0) {
        var planID = userPlan[0]['plan_id'];
    }

    // console.log({ orders: orders });
    const columns = [
        {
            name: "Order ID",
            style: {
                color: '#0089ff ',
                fontSize: '14px',
                fontWeight: '500',
                padding: '8px 16px',
            },
            sortable: true,
            //selector: (row) => row.order_unique_key,
            cell: row => {
                function getKeyByValue(object, row) {
                    return object[row];
                }
                return (
                    <a
                        className="productName"
                        onClick={() => navigateOrderDetails(row.order_unique_key, type)}
                        rel="noopener noreferrer">
                        {row.order_unique_key}
                    </a>
                );
            },
        },
        {
            name: "Buyer Name",
            style: {
                color: '#515563',
                fontSize: '14px',
                fontWeight: '600',
            },
            sortable: true,
            selector: (row) => row.full_name,
        },
        {
            name: 'Total Quantity',

            style: {
                color: '#515563',
                fontSize: '14px',
                fontWeight: '600',
            },
            sortable: true,
            selector: (row) => row.total_quantity
        },
        {
            name: 'Total Amount',
            style: {
                color: 'black',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => (parseFloat(row.ammount) || 0).toFixed(2)
        },
        {
            name: 'Order Date',

            style: {
                color: '#515563',
                fontSize: '14px',
                fontWeight: '600',
            },
            sortable: true,
            selector: (row) => moment(row.order_created_date).format(' MMM DD YYYY'),
        },


        {
            name: 'Update Date',
            width: '150px',
            style: {
                color: 'black ',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => moment(row.order_modified_date).format(' MMM DD YYYY'),
        },
        {
            name: "Order Status",
            sortable: true,
            conditionalCellStyles: [
                {
                    when: row => row.order_status == 1,
                    style: { fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', color: 'rgb(255 255 255)', backgroundColor: 'rgb(30, 88, 255)' },
                },
                {
                    when: row => row.order_status == 2,
                    style: { fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', color: 'white', backgroundColor: '#1aaa55' },
                },
                {
                    when: row => row.order_status == 3,
                    style: { fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', color: 'white', backgroundColor: '#fc5d20' },
                },
                {
                    when: row => row.order_status == 4,
                    style: { fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', color: 'white', backgroundColor: '#017e6b' },
                },
                {
                    when: row => row.order_status == 5,
                    style: { fontSize: '14px', fontWeight: '700', color: 'white', backgroundColor: 'rgb(1, 97, 126)' },
                },
                {
                    when: row => row.order_status == 6,
                    style: { fontSize: '14px', fontWeight: '700', color: 'white', backgroundColor: 'rgb(89, 1, 126)' },
                },
                {
                    when: row => row.order_status == 7,
                    style: { fontSize: '14px', fontWeight: '700', color: '#035205', backgroundColor: '#bdffd1' },
                },
                {
                    when: row => row.order_status == 8,
                    style: { fontSize: '14px', fontWeight: '700', color: 'rgb(72 8 64)', backgroundColor: 'rgb(243 195 237)' },
                },
                {
                    when: row => row.order_status == 9,
                    style: { fontSize: '14px', fontWeight: '700', color: '#014006', backgroundColor: 'rgb(0 193 15 / 52%)' },
                },
                {
                    when: row => row.order_status == 10,
                    style: { fontSize: '14px', fontWeight: '700', color: '#600101', backgroundColor: 'rgb(243 171 171)' },
                },
                {
                    when: row => row.order_status == 11,
                    style: { fontSize: '14px', fontWeight: '700', color: 'red', backgroundColor: 'rgb(255 163 163 / 60%)' },
                },
            ],
            selector: (row) => {
                return (
                    (row.order_status === 1) ? 'Order Placed' :
                        (row.order_status === 2) ? 'Confirmed' :
                            (row.order_status === 3) ? 'onhold' :
                                (row.order_status === 4) ? 'processing' :
                                    (row.order_status === 5) ? 'packed' :
                                        (row.order_status === 6) ? 'dispatched' :
                                            (row.order_status === 7) ? 'Completed' :
                                                (row.order_status === 8) ? 'intransit' :
                                                    (row.order_status === 9) ? 'Delivered' :
                                                        (row.order_status === 10) ? 'cancelled' :
                                                            (row.order_status === 11) ? 'outofstock' : null
                )
            }
        },
    ];


    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }


    const planPricePerMonth = 0;
    const orderPricePerOrder = 2.5;

    const [orderss, setOrders] = useState(0);

    // Orders increment/decrement (in multiples of 100)
    const handleOrderIncrease = () => setOrders((prev) => prev + 100);
    const handleOrderDecrease = () => setOrders((prev) => (prev >= 100 ? prev - 100 : 0));

    // Calculations
    const usersTotalPerMonth = orderss * orderPricePerOrder;
    const usersTotalYearly = usersTotalPerMonth;
    const ordersTotal = orderss * orderPricePerOrder;

    const planTotalYearly = planPricePerMonth;
    const subTotal = planTotalYearly + usersTotalYearly;
    const gst = subTotal * 0.18;
    const grandTotal = subTotal + gst;


    async function displayRazorpay() {

        // alert('Payment Gatway call');
        const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

        if (!res) {
            // alert("Razorpay SDK failed to load. Are you online?");
            return;
        }

        // creating a new order
        const result = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Payment`, { plan_name: "new_user_add", cart_ammount: grandTotal * 100, plan_currency: "INR", check: 2 }, { withCredentials: true });
        // console.log({ result: result });
        if (!result) {
            return;
        }

        const options = {
            key: "rzp_test_HHHXi6bhZ0bIvf", // This is Api key. you will get it from razorpay dashboard > account and settings > API keys
            amount: parseInt(grandTotal * 100),
            currency: "INR", // your 3 letter currency code
            name: username, // project or transaction name
            description: "Test Transaction",
            order_id: result.data.order.id,
            // image: { sidebarLogo }, // your project logo
            handler: function (response) {
                // console.log("response", response);
                orderPlace(response, 3, grandTotal); // after payment completes on stripe this function will be called and you can do your stuff
            },
            prefill: {
                name: username,
                email: EmailAddress,
                contact: '852369741',
            },
            notes: {
                address: "India",
            },
            theme: {
                color: "#158993",
            },
        };

        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
    }

    const orderPlace = async (response, check, total) => {
        // console.log(response);
        // console.log(plan);
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/purchasePlan`, { response, check, order_count: orderss, grandTotal: total }, { withCredentials: true })
                .then((res) => {
                    if (res.data.success === 1) {
                        StopLoading(setisLoading);
                        setLgShow(false)
                        // console.log(res.data.data);
                        showToast("success ", 'success');

                    }
                    else {
                        StopLoading(setisLoading);
                        setLgShow(false);
                        showToast("Failed to get purchasePlan, please try again later ", 'error');
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        console.error('Server responded with a status:', err.response.status);
                        console.error('Response data:', err.response.data);
                    } else if (err.request) {
                        console.error('No response received:', err.request);
                    } else {
                        console.error('Error setting up request:', err.message);
                    }
                    // toastifn(0, "Something went wrong! Please try again later.");
                });
        } catch (err) {
            // StopLoading(setisLoading);
            showToast("Failed to get purchasePlan, please try again later ", 'error');
        }
    }

    return (
        <div className="md:flex md:flex-row md:w-full">
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} currentplan={planID} ActiveUser={ActiveUser} />
            </div>
            <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
                <div className="w-full p-3">


                    <div className="col-start-1 col-end-13">
                        <div className=" p-2 mb-3 text-xl  text-[#1e3a8a]    ">
                            <h1 className=' text-lg text-theme-color-text font-bold'> Orders </h1>
                            <p className=' text-gray-600 text-[16px] '>Manage all your orders in one place and track their status with ease.Ensure timely delivery to your buyers. </p>
                        </div>
                    </div>

                    <div class="col-start-1 col-end-13">
                       
                            <div class="flex flex-col lg:grid lg:grid-cols-12 lg:px-8 bg-gray-900 text-white rounded-md p-4">
                                <div class="flex-grow flex flex-col  lg:col-span-10">
                                    <h2 class="text-base sm:text-lg md:text-md lg:text-xl font-semibold">No Orders Yet!</h2>
                                    <p class="mt-2 text-sm sm:text-base md:text-md lg:text-md">
                                        You haven’t received any orders so far. Upgrade your plan to start getting new orders and grow your business.
                                    </p>
                                </div>

                                {ActiveUser === 1 && (
                                    <div class="lg:col-span-2 lg:flex lg:justify-end mt-4 sm:mt-6 lg:mt-0">
                                        <button
                                        onClick={() => setLgShow(true)}
                                            class="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium text-sm sm:text-base md:text-md lg:text-md">
                                            Upgrade Plan
                                        </button>
                                    </div>
                                )}
                            </div>
                        
                    </div>






                    {(orders && orders.length > 0) ? (
                        <div className="col-start-1 col-end-13">
                            <div className="border-0 flex-row rounded-xl m-2 p-2 bg-white shadow-xs">
                                <div className=' relative flex flex-col min-w-0 break-words'>
                                    <div className='p-3'>
                                        {/* <h5 className="capitalize text-md font-semibold mb-0">View Orders</h5> */}
                                        <div className='flex flex-row justify-between items-center mb-1'>
                                            <div className='rounded-b-md mt-5  overflow-x-hidden bg-white flex flex-row items-center justify-between w-[20%] '>
                                                <div className=" justify-start float-left w-full  ">
                                                    <div className='relative bg-gray-100 p-2 w-full  rounded-md border-2 border-solid border-gray-200' >
                                                        <FaSearch className='h-5 w-5 absolute left-3 ' />
                                                        <input className="bg-transparent ml-6 pl-5 focus:outline-none w-full pr-5  " type="text" name="searchbox" id='searchbox' placeholder='Search anything from table '
                                                            value={seacrh}
                                                            onChange={(e) => setSearch(e.target.value)} />
                                                    </div>

                                                </div>
                                            </div>

                                            <div className=' rounded-b-md mt-5  overflow-x-hidden bg-white flex flex-row items-center justify-between'>

                                                {ActiveUser === 1 &&
                                                    <div className=' w-40 font-medium h-100 mx-3 z-50'>
                                                        <div onClick={() => setOpen(!open)} className='border-[1px] border-solid border-[#e5e5e5] w-40 p-2 flex items-left justify-between rounded'>
                                                            {Selected ? Selected?.length > 25 ? Selected?.substring(0, 25) + '... ' : Selected : "Order Status"}
                                                            <BiChevronDown size={20} className={`${open && 'rotate-180'}`} />
                                                        </div>
                                                        <ul className={`bg-white absolute w-40 border-l-[1px] border-r-[1px] border-b-[1px] border-t-0  border-solid border-[#e5e5e5] overflow-y-auto max-h-60 opacity-0 z-50  rounded ${open ? "max-h-60 opacity-100" : "max-h-0 opacity-0 hidden"}  ${!Selected && "text-gray-700"}`}>
                                                            {/* <div className='w-full p-2 sticky top-0 bg-white border-[1px] border-solid border-[#e5e5e5]'>
        {/* <input type="text" placeholder="Search" className='border-[1px] border-solid border-[#e5e5e5] rounded bg-white placeholder:text-gray-700 p-2 h-[35px] w-[100%] outline-none' onChange={(e) => setInputValue(e.target.value.toLocaleLowerCase())} value={inputValue} /> }
     </div> */}

                                                            {
                                                                Array.isArray(orderTypes) && orderTypes?.map((ordertype) => (
                                                                    <li
                                                                        key={ordertype.id}
                                                                        className={`cursor-pointer p-2 py-2 border-b border-solid border-[#f4f4f4] text-sm hover:bg-[#e3e3e3] hover:text-black
                                                            ${ordertype?.order_status_name?.toLowerCase() === Selected?.toLowerCase() && 'bg-gray-200 text-black cursor-pointer'}
                                                            ${ordertype.order_status_name?.toLowerCase().startsWith(inputValue) ? 'block' : 'hidden'}`
                                                                        }
                                                                        name="main_category"
                                                                        id="main_Category"
                                                                        value={ordertype.order_status_name}
                                                                        onClick={(e) => {
                                                                            // console.log(ordertype.order_status_name?.toLowerCase())
                                                                            // console.log(Selected?.toLowerCase())
                                                                            // console.log(ordertype.id)
                                                                            if (ordertype.order_status_name?.toLowerCase() !== Selected.toLowerCase()) {

                                                                                setSelected(ordertype.order_status_name);
                                                                            }
                                                                            setOpen(false);
                                                                            setInputValue('');
                                                                            handleupdateorderState(ordertype.id);
                                                                        }}
                                                                    >
                                                                        {ordertype.order_status_name}
                                                                    </li>
                                                                ))
                                                            }

                                                        </ul>
                                                        <Modal size="md" show={lgShow1} onHide={() => handlemodalhide()} aria-labelledby="example-modal-sizes-title-lg">
                                                            <Modal.Body>
                                                                <div className="relative border-b border-slate-200/60 py-3">
                                                                    <label className=" text-lg"> Add New Sub Category</label>
                                                                    <div className="h-6 text-xs bg-slate-200 text-slate-500 px-2 flex items-center rounded-md absolute inset-y-0 right-0 my-auto mr-4 cursor-pointer" onClick={() => handlemodalhide()}> ESC / Close </div>
                                                                </div>
                                                                <div className='py-4'>
                                                                    {/* onSubmit={handlecustomfieldsubmit} */}
                                                                    <form method='POST' onSubmit={handleSubmit} >
                                                                        <div className='row'>
                                                                            <div className="grid grid-cols-1 gap-3">
                                                                                {
                                                                                    usercustomfields.map((item, index) => (

                                                                                        (item.custom_field_type === 1) ?
                                                                                            <div className='flex flex-row'>
                                                                                                <label className="block ">
                                                                                                    <span className="block w-20 text-sm p-2 font-medium text-slate-700">{item.custom_fileds_label} </span>
                                                                                                </label>
                                                                                                <div class='bg-transparent mb-5 flex relative border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md '>
                                                                                                    {/* <BiCategory className='text-theme-color-yellow' /> */}
                                                                                                    <input
                                                                                                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                                                                                                        type='text'
                                                                                                        name={"customfield" + index}
                                                                                                        id={item.id}
                                                                                                        onChange={handlenameChange}
                                                                                                    //  value={values.customfield + index}

                                                                                                    />
                                                                                                </div>
                                                                                            </div> : (item.custom_field_type === 2) ? <div className='flex flex-row'> <label className="block ">
                                                                                                <span className="block w-20 text-sm  p-2 font-medium text-slate-700">{item.custom_fileds_label}</span>
                                                                                            </label>
                                                                                                <input type="file" className="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-theme-color-yellow hover:file:bg-violet-100"
                                                                                                    name={"customfield" + index}
                                                                                                    id={item.id}
                                                                                                    onChange={handleonchange}
                                                                                                /></div> : (item.custom_field_type === 3) ?
                                                                                                <div className='flex flex-row'>
                                                                                                    <label className="block ">
                                                                                                        <span className="block w-20 text-sm p-2 font-medium text-slate-700">{item.custom_fileds_label} </span>
                                                                                                    </label>
                                                                                                    <div class='bg-transparent mb-5 flex relative border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md '>
                                                                                                        {/* <BiCategory className='text-theme-color-yellow' /> */}
                                                                                                        <input
                                                                                                            className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                                                                                                            type='date'
                                                                                                            name={"customfield" + index}
                                                                                                            id={item.id}
                                                                                                            onChange={handlenameChange}

                                                                                                        />
                                                                                                    </div>
                                                                                                </div> : (item.custom_field_type === 4) ?
                                                                                                    <div className='flex flex-row'>
                                                                                                        <label className="block ">
                                                                                                            <span className="block w-20 text-sm p-2 font-medium text-slate-700">{item.custom_fileds_label} </span>
                                                                                                        </label>
                                                                                                        <textarea id={item.id} name={"customfield" + index} rows="4" className="block p-2.5 w-full text-sm rounded-lg !border-[1px] !border-gray-300 focus:ring-blue-500 focus:border-blue-500  dark:placeholder-gray-400 dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={handlenameChange}></textarea></div> : null

                                                                                    )
                                                                                    )
                                                                                }
                                                                            </div>

                                                                            <button type="submit" className="relative rounded-md group px-3 h-12 mt-5 ml-2 flex space-x-2 items-center bg-button-color  hover:bg-button-color w-[150px]" onClick={handleSubmit}>
                                                                                <span className="relative text-md text-black font-semibold pl-3">Submit</span>
                                                                                <div className="flex items-center h-12 w-12 rounded-full bg-button-color absolute right-[0px] z-20 drop-shadow-2xl ">
                                                                                    <FaArrowAltCircleRight className="h-3 w-3 text-black translate-x-4 transition duration-300 group-hover:scale-[2]" />
                                                                                </div>
                                                                            </button>
                                                                        </div>
                                                                    </form>
                                                                </div>
                                                            </Modal.Body>
                                                        </Modal>
                                                    </div>
                                                }

                                                {/* <button type="submit" className="relative rounded-md group pr-8 p-4 h-6  flex space-x-2 items-center border-[1px] border-solid border-gray-500  text-white " >
                                            <span className="relative text-sm text-gray-600 font-semibold pl-0 mr-2">Download Projection Report</span>
                                            <div className="flex items-center h-6 w-12 rounded-full  absolute right-[0px] z-20 drop-shadow-2xl   ">
                                                <FaFileExcel className="h-4 w-4 mr-2 ml-1 text-gray-600 translate-x-3 transition duration-300 " />
                                            </div>
                                        </button> */}
                                                <button type="submit" className="relative rounded-md group pr-8 p-4 h-6 mx-2  flex space-x-2 items-center border-[1px] border-solid border-gray-500  text-white " onClick={() => exporttoExcelData()}>
                                                    <span className="relative text-sm text-gray-600 font-semibold pl-0 mr-2">Download Excelsheet</span>
                                                    <div className="flex items-center h-6 w-12 rounded-full  absolute right-[0px] z-20 drop-shadow-2xl   ">
                                                        <FaFileExcel className="h-4 w-4 mr-2 ml-1 text-gray-600 translate-x-3 transition duration-300 " />
                                                    </div>
                                                </button>
                                                <button type="submit" className="relative rounded-md group pr-8 p-4 h-6 mx-2  flex space-x-2 items-center border-[1px] border-solid border-gray-500  text-white " onClick={() => setfilterDiv(!filterDiv)}>
                                                    <span className="relative text-sm text-gray-600 font-semibold pl-0 mr-2">Filter</span>
                                                    <div className="flex items-center h-6 w-12 rounded-full  absolute right-[0px] z-20 drop-shadow-2xl   ">
                                                        <FaFilter className="h-4 w-4 mr-2 ml-1 text-gray-600 translate-x-3 transition duration-300 " />
                                                    </div>
                                                </button>
                                                <button type="submit" className="relative rounded-md group pr-8 p-4 h-6 mx-2  flex space-x-2 items-center border-[1px] border-solid border-gray-500  text-white " onClick={() => getsellerOrders()}>
                                                    <span className="relative text-sm text-gray-600 font-semibold pl-0 mr-2">Refresh</span>
                                                    <div className="flex items-center h-6 w-12 rounded-full  absolute right-[0px] z-20 drop-shadow-2xl   ">
                                                        <MdRefresh className="h-5 w-5 mr-2 ml-1 text-gray-600 translate-x-3 transition duration-300 " />
                                                    </div>
                                                </button>

                                            </div>
                                        </div>

                                        {(filterDiv) ? (
                                            <div className='border border-gray-300 my-1 py-2 rounded-md transition-all duration-500'>
                                                <div className="px-2">
                                                    <form method='POST'>
                                                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-7 gap-2">

                                                            {/* Search Order ID */}
                                                            <div className="relative bg-gray-100 rounded-md border border-gray-200 h-12">
                                                                <input
                                                                    className="bg-transparent px-3 focus:outline-none w-full h-full"
                                                                    type="text"
                                                                    name="searchorderid"
                                                                    id="searchorderid"
                                                                    placeholder="Search Order ID"
                                                                    value={seacrhOrderId}
                                                                    onChange={(e) => setSearchOrderId(e.target.value)}
                                                                />
                                                            </div>

                                                            {/* Search Buyer Name */}
                                                            <div className="relative bg-gray-100 rounded-md border border-gray-200 h-12">
                                                                <input
                                                                    className="bg-transparent px-3 focus:outline-none w-full h-full"
                                                                    type="text"
                                                                    name="searchbuyername"
                                                                    id="searchbuyername"
                                                                    placeholder="Search Buyer Name"
                                                                    value={seacrhBuyername}
                                                                    onChange={(e) => setSearchBuyername(e.target.value)}
                                                                />
                                                            </div>

                                                            {/* Min/Max Qty */}
                                                            <div className="flex gap-1 bg-gray-100 rounded-md border border-gray-200 h-12 p-1">
                                                                <input
                                                                    className="bg-transparent px-2 focus:outline-none w-1/2 border-r border-gray-300"
                                                                    type="text"
                                                                    name="searchminqty"
                                                                    id="searchminqty"
                                                                    placeholder="Min Qty"
                                                                    value={seacrhMinQty}
                                                                    onChange={(e) => setSearchMinQty(e.target.value)}
                                                                />
                                                                <input
                                                                    className="bg-transparent px-2 focus:outline-none w-1/2"
                                                                    type="text"
                                                                    name="searchmaxqty"
                                                                    id="searchmaxqty"
                                                                    placeholder="Max Qty"
                                                                    value={seacrhMaxQty}
                                                                    onChange={(e) => setSearchMaxQty(e.target.value)}
                                                                />
                                                            </div>

                                                            {/* Min/Max Amount */}
                                                            <div className="flex gap-1 bg-gray-100 rounded-md border border-gray-200 h-12 p-1">
                                                                <input
                                                                    className="bg-transparent px-2 focus:outline-none w-1/2 border-r border-gray-300"
                                                                    type="text"
                                                                    name="searchminamt"
                                                                    id="searchminamt"
                                                                    placeholder="Min Amt"
                                                                    value={seacrhMinAmt}
                                                                    onChange={(e) => setSearchMinAmt(e.target.value)}
                                                                />
                                                                <input
                                                                    className="bg-transparent px-2 focus:outline-none w-1/2"
                                                                    type="text"
                                                                    name="searchmaxamt"
                                                                    id="searchmaxamt"
                                                                    placeholder="Max Amt"
                                                                    value={seacrhMaxAmt}
                                                                    onChange={(e) => setSearchMaxAmt(e.target.value)}
                                                                />
                                                            </div>

                                                            {/* Date Range (From/To) */}
                                                            <div className="flex gap-1 bg-gray-100 rounded-md border border-gray-200 h-12 p-1">
                                                                {/* From Date */}
                                                                <input
                                                                    className="bg-transparent  focus:outline-none cursor-pointer w-1/2 text-sm min-w-[120px]"
                                                                    type="date"
                                                                    name="searchfromdate"
                                                                    id="searchfromdate"
                                                                    placeholder="From"
                                                                    value={seacrhFromdate}
                                                                    onChange={(e) => setSearchFromdate(e.target.value)}
                                                                    onClick={(e) => e.target.showPicker()} // Force open date picker on click
                                                                />

                                                                {/* To Date */}
                                                                <input
                                                                    className="bg-transparent  focus:outline-none cursor-pointer w-1/2 text-sm min-w-[120px]"
                                                                    type="date"
                                                                    name="searchtodate"
                                                                    id="searchtodate"
                                                                    placeholder="To"
                                                                    value={seacrhTodate}
                                                                    onChange={(e) => setSearchTodate(e.target.value)}
                                                                    onClick={(e) => e.target.showPicker()} // Force open date picker on click
                                                                />
                                                            </div>

                                                            {/* Updated Date Range */}
                                                            <div className="flex gap-1 bg-gray-100 rounded-md border border-gray-200 h-12 p-1">
                                                                <input
                                                                    className="bg-transparent px-2 focus:outline-none w-1/2 text-sm min-w-[80px]"
                                                                    type="date"
                                                                    name="searchupdatefromdate"
                                                                    id="searchupdatefromdate"
                                                                    placeholder="Updated From"
                                                                    value={seacrhUpdateFromdate}
                                                                    onChange={(e) => setSearchUpdateFromdate(e.target.value)}
                                                                />
                                                                <input
                                                                    className="bg-transparent px-2 focus:outline-none w-1/2 text-sm min-w-[80px]"
                                                                    type="date"
                                                                    name="searchupdatetodate"
                                                                    id="searchupdatetodate"
                                                                    placeholder="Updated To"
                                                                    value={seacrhUpdateTodate}
                                                                    onChange={(e) => setSearchUpdateTodate(e.target.value)}
                                                                />
                                                            </div>

                                                            {/* Order Status Dropdown */}
                                                            <div className="relative  font-medium h-12">
                                                                <div
                                                                    onClick={() => setfilterOpen(!filteropen)}
                                                                    className='border border-[#e5e5e5] w-full p-3 flex items-center justify-between rounded bg-gray-100 h-12'
                                                                >
                                                                    <span className="truncate">
                                                                        {filterSelected ? (filterSelected.length > 15 ? filterSelected.substring(0, 15) + '...' : filterSelected) : "Order Status"}
                                                                    </span>
                                                                    <BiChevronDown size={20} className={`transition-transform ${filteropen ? 'rotate-180' : ''}`} />
                                                                </div>
                                                                <ul
                                                                    className={`bg-white absolute w-full border border-[#e5e5e5] mt-1 rounded-md shadow-lg overflow-hidden transition-all duration-200 z-50 ${filteropen ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
                                                                        }`}
                                                                >
                                                                    {orderTypes?.map((ordertype) => (
                                                                        <li
                                                                            key={ordertype.id}
                                                                            className={`p-2 text-sm hover:bg-gray-100 cursor-pointer ${ordertype.order_status_name?.toLowerCase() === filterSelected?.toLowerCase() ? 'bg-gray-200' : ''
                                                                                }`}
                                                                            onClick={() => {
                                                                                if (ordertype.order_status_name?.toLowerCase() !== filterSelected?.toLowerCase()) {
                                                                                    setfilterSelected(ordertype.order_status_name);
                                                                                }
                                                                                setfilterOpen(false);
                                                                                setSearchOrderType(ordertype.id);
                                                                            }}
                                                                        >
                                                                            {ordertype.order_status_name}
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        ) : null}
                                        <DataTable
                                            className="scrollhost"
                                            columns={columns}
                                            data={filteredCategories}
                                            selectableRows
                                            pagination
                                            responsive

                                            onSelectedRowsChange={handleRowSelected}
                                            sortIcon={<BsSortUpAlt className="mx-1" />}
                                            selectableRowDisabled={(row) =>
                                                row.order_status === 9 ||
                                                row.order_status === 7 ||
                                                row.order_status === 6
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>) : <center><img src={noDatapng} height={260} width={260} /> <h1 className='text-lg -translate-y-10 text-gray-300 font-bold'> Opps ! No Data Found </h1></center>
                    }
                </div>


                <Modal size="lg" show={lgShow} onHide={() => setLgShow(false)} aria-labelledby="example-modal-sizes-title-lg">
                    <Modal.Body>
                        <div className="relative border-b border-slate-200/60 py-2">
                            <label className=" text-lg"> Add New User</label>
                            <div className="h-6 text-xs bg-slate-200 text-slate-500 px-2 flex items-center rounded-md absolute inset-y-0 right-0 my-auto mr-4 cursor-pointer" onClick={() => setLgShow(false)}> ESC / Close </div>
                        </div>
                        <div className='p-2'>
                            <div className="p-6 w-full border-t-2 border-solid border-t-gray-300">
                                <div className="w-full">
                                    {/* Selected Plan */}


                                    {/* Additional Users */}
                                    <div className="border-b pb-4 mb-6">
                                        <div className="flex justify-between items-center mb-2">
                                            <span className="font-semibold text-gray-800 text-lg">Additional Orders ({orderss})</span>
                                            <div className="flex items-center gap-2">
                                                <button
                                                    onClick={handleOrderDecrease}
                                                    className="bg-gray-200 hover:bg-gray-300 p-2 rounded-full shadow"
                                                >
                                                    <FaMinus />
                                                </button>
                                                <span className="text-lg font-bold w-12 text-center">{orderss}</span>
                                                <button
                                                    onClick={handleOrderIncrease}
                                                    className="bg-pink-500 hover:bg-pink-600 text-white p-2 rounded-full shadow"
                                                >
                                                    <FaPlus />
                                                </button>
                                            </div>
                                        </div>
                                        <div className="flex justify-between text-gray-700 bg-gray-100 p-3 rounded-lg">
                                            <span>Validity: 12 Months</span>

                                            <span>Per User Per Month: <span className="font-bold">₹{orderPricePerOrder}</span></span>
                                            <span>Total: <span className="font-bold">₹{ordersTotal.toFixed(2)}</span></span>


                                        </div>
                                    </div>

                                    {/* Summary */}
                                    <div className="space-y-3 text-gray-800 bg-gray-50 p-4 rounded-lg">
                                        <div className="flex justify-between">
                                            <span className="text-gray-600">Sub-Total</span>
                                            <span className="font-semibold">₹{subTotal.toFixed(2)}</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className="text-gray-600">GST (18%)</span>
                                            <span className="font-semibold">₹{gst.toFixed(2)}</span>
                                        </div>
                                        <div className="flex justify-between font-bold text-xl border-t pt-3">
                                            <span>Total</span>
                                            <span>₹{grandTotal.toFixed(2)}</span>
                                        </div>
                                    </div>

                                    <div className='flex justify-end
                                                                          mt-4'>
                                        <button type="button" className="relative rounded-md group px-3 h-12  flex space-x-2 items-center bg-button-color  hover:bg-button-color "
                                            onClick={displayRazorpay}
                                        >
                                            <span className="relative text-md text-black font-semibold ">Continue to Checkout</span>

                                        </button >
                                    </div>
                                </div>
                            </div>

                        </div>
                    </Modal.Body>
                </Modal>


            </div>
            <ToastContainer />
        </div>
    )
}

export default ViewSellerOrders